const colors = [
    { value: 'black', label: { en: 'Black', es: 'Negro' } },
    { value: 'white', label: { en: 'White', es: 'Blanco' } },
    { value: 'brown', label: { en: 'Brown', es: 'Marrón' } },
    { value: 'gray', label: { en: 'Gray', es: 'Gris' } },
    { value: 'golden', label: { en: 'Golden', es: 'Dorado' } },
    { value: 'cream', label: { en: 'Cream', es: 'Crema' } },
];

export default colors;